import api from '../../api'

// Utilities
import Logger from '../../utility/loggerUtil'

export default {
  async getContactInfo (context) {
    try {
      const contactInfo = await api.config.getContactUs()

      Logger.info('Got contact info')
      Logger.debug(contactInfo)

      context.commit('setContactInfo', { contactInfo })
    } catch (e) {
      if (e.response && e.response.data) {
        throw new Error(e.response.data)
      }

      throw e
    }
  }
}
